var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchRequest from "./fetch_requests/FetchRequest";
import RequestsQueue from "./fetch_requests/RequestsQueue";
import CacheContainer from "../models/CacheContainer";
import CQRSCommand from "../models/CQRSCommand";
import NullWebsocketConnector from "./websockets/NullWebsocketConnector";
export default class ApiEngine {
    get websocketConnector() {
        return this._websocketConnector;
    }
    set websocketConnector(value) {
        this._websocketConnector = value;
    }
    get canUseOutsideLinks() {
        return this._canUseOutsideLinks;
    }
    set canUseOutsideLinks(value) {
        this._canUseOutsideLinks = value;
    }
    get cacheContainer() {
        return this._cacheContainer;
    }
    set cacheContainer(value) {
        this._cacheContainer = value;
    }
    constructor(_serverUrl, _requestsFetchingRate, _sessionContainer) {
        this.serverUrl = _serverUrl;
        this.requestsFetchingRate = _requestsFetchingRate;
        this.sessionContainer = _sessionContainer;
        this.sessionContainer.apiEngine = this;
        this.startQueue = this.startQueue.bind(this);
        this.asyncFetch = this.asyncFetch.bind(this);
        this.asyncFetchWithCache = this.asyncFetchWithCache.bind(this);
        this.prioritizedAsyncFetchWithCache = this.prioritizedAsyncFetchWithCache.bind(this);
        this.asyncFetchWithRetries = this.asyncFetchWithRetries.bind(this);
        this.whatsWrong = this.whatsWrong.bind(this);
        this.asyncFetchWithoutQueing = this.asyncFetchWithoutQueing.bind(this);
        this.cleanQueue = this.cleanQueue.bind(this);
        this.updateToken = this.updateToken.bind(this);
        this.asyncFetchBlobWithoutQueing = this.asyncFetchBlobWithoutQueing.bind(this);
        this.corsFetch = this.corsFetch.bind(this);
        this._canUseOutsideLinks = false;
        this._cacheContainer = new CacheContainer("default_api_storage");
        this._websocketConnector = new NullWebsocketConnector("/", this);
    }
    startQueue() {
        const me = this;
        console.log("Starting queing process");
        if (!this.requestsQueue) {
            console.log("Creating queue");
            this.requestsQueue = new RequestsQueue(me.requestsFetchingRate, me);
            console.log("Starting queue");
            this.requestsQueue.start();
        }
        else {
            console.log("Restarting queue");
            this.requestsQueue.start();
        }
    }
    asyncFetch(_url, _dataToSend) {
        return this.asyncFetchWithRetries(_url, _dataToSend, 5, false, 0);
    }
    asyncFetchWithCache(_url, _dataToSend) {
        console.log("Using cache");
        return this.prioritizedAsyncFetchWithCache(_url, _dataToSend, 0);
    }
    prioritizedAsyncFetchWithCache(_url, _dataToSend, _priority) {
        console.log(`Checking for key ${_url}`);
        ;
        let cachedData = this.cacheContainer.getKey(_url);
        if (cachedData)
            return new Promise((_resolve) => {
                _resolve(cachedData);
            });
        return this.asyncFetchWithRetries(_url, _dataToSend, 5, true, _priority);
    }
    asyncFetchWithRetries(_url, _dataToSend, _numOfRetriesBeforeReject, _cacheAnswer, _priority) {
        const me = this;
        let url = new URL(`${me.serverUrl}/${_url}`.replace(/([^:]\/)\/+/g, "$1"));
        if ((_url.indexOf("https://") > -1) || (_url.indexOf("http://") > -1)) {
            if (me.canUseOutsideLinks) {
                url = new URL(_url.replace(/([^:]\/)\/+/g, "$1"));
            }
        }
        if (!me.requestsQueue)
            return me.whatsWrong();
        let request = new FetchRequest(url, _dataToSend, this.sessionContainer, _numOfRetriesBeforeReject, _cacheAnswer ? this.cacheContainer : null, _url);
        request.priority = _priority;
        me.requestsQueue.push(request);
        return request.make();
    }
    corsFetch(_command, _params, _isBlob, _sendUrl, _ticketCheckEndPoint, _updateCallback = undefined) {
        return new Promise((_resolve) => {
            let cqrsCommand = new CQRSCommand(_command, _params, _isBlob, _sendUrl, this, 1000, _ticketCheckEndPoint, _updateCallback);
            cqrsCommand.makeRequest().then((_res) => {
                _resolve(_res);
            });
        });
    }
    testFetch(_url, _dataToSend, _expectedResult, _timeToAnswerInMs) {
        const me = this;
        return new Promise((_resolve, _reject) => {
            setTimeout(() => {
                _resolve(_expectedResult);
            }, _timeToAnswerInMs);
        });
    }
    testFetchAndFail(_url, _dataToSend, _expectedFail, _timeToAnswerInMs) {
        const me = this;
        return new Promise((_resolve, _reject) => {
            setTimeout(() => {
                _reject(_expectedFail);
            }, _timeToAnswerInMs);
        });
    }
    asyncFetchWithoutQueing(_url, _dataToSend, _numOfRetriesBeforeReject = 0) {
        const me = this;
        let url = new URL(`${me.serverUrl}/${_url}`.replace(/([^:]\/)\/+/g, "$1"));
        return new Promise((_resolve, _reject) => {
            if ((_url.indexOf("https://") > -1) || (_url.indexOf("http://") > -1)) {
                if (me.canUseOutsideLinks) {
                    url = new URL(_url.replace(/([^:]\/)\/+/g, "$1"));
                }
            }
            let request = new FetchRequest(url, _dataToSend, this.sessionContainer, _numOfRetriesBeforeReject, null, _url);
            request.perform().then((_res) => {
                _resolve(_res);
            }, (_err) => {
                _reject(_err);
            });
        });
    }
    asyncFetchBlobWithoutQueing(_url, _dataToSend, _numOfRetriesBeforeReject = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const me = this;
            let url = new URL(`${me.serverUrl}/${_url}`.replace(/([^:]\/)\/+/g, "$1"));
            return new Promise((_resolve, _reject) => {
                if ((_url.indexOf("https://") > -1) || (_url.indexOf("http://") > -1)) {
                    if (me.canUseOutsideLinks) {
                        url = new URL(_url.replace(/([^:]\/)\/+/g, "$1"));
                    }
                }
                let request = new FetchRequest(url, _dataToSend, this.sessionContainer, _numOfRetriesBeforeReject, null, _url);
                request.isBlob = true;
                request.perform().then((_res) => {
                    _resolve(_res);
                }).catch((_e) => {
                    _reject(_e);
                });
            });
        });
    }
    cleanQueue() {
        if (this.requestsQueue)
            this.requestsQueue.clean();
    }
    whatsWrong() {
        const me = this;
        return new Promise((resolve, reject) => {
            let reason = "";
            if (!me.requestsQueue)
                reason += "Не инициализировано requestsQueue;";
            reject(reason);
        });
    }
    updateToken(_token) {
        this.sessionContainer.updateToken(_token);
    }
}
